import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment'
import { connect } from 'react-redux';
import { push } from 'actions';

class OpportunityCard extends React.Component {
  render() {
    const {
      job,
      style,
      container_class_name
    } = this.props;
    const { name } = job.assigned_to;
    const assigned_to_name = name ? `${name.first || ''} ${name.last || ''}` : job.assigned_to.username || '';

    return (
      <section
        onClick={e => this.props.push(`/opportunities-table/${job._id}`)}
        style={{ cursor: 'pointer' }}
        className={`panel panel-featured-left panel-featured-${style} ${container_class_name}`}
        >
        <div className='panel-body'>
          <div className='widget-summary widget-summary-sm'>
            <div className='widget-summary-col widget-summary-col-icon'>
              <div className={`summary-icon bg-${style}`}>
                <i className='fa fa-user' />
              </div>
            </div>
            <div className='widget-summary-col'>
              <div className='summary'>
                <h4 className='title'>{job.client ? job.client.name : ''}</h4>
                <div className='info'>
                  <strong><i className='fa fa-calendar'></i> {moment(job.updated_timestamp).format('MMM DD, YYYY h:mm')}</strong>
                  <br />
                  <span className='text-primary'>${(job.estimate || 0).toLocaleString()}</span>
                  <br />
                  {assigned_to_name ? (
                    <p>
                      Assigned To:
                      <br />
                      <span className='text-tertiary'>
                        {assigned_to_name}
                      </span>
                    </p>
                  ) : null}
                  {job.assigned_to._id == this.props.user._id ? <span className='text-tertiary'>You own this opportunity.</span> : null}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    )
  }
}

const style_options = [
  'primary',
  'secondary',
  'tertiary',
  'quartenary',
  'success',
  'warning',
  'info',
  'dark',
  'danger'
];

OpportunityCard.PropTypes = {
  job: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  style: PropTypes.oneOf(style_options).isRequired,
  container_class_name: PropTypes.string
}

export default connect(null, { push })(OpportunityCard);



// WEBPACK FOOTER //
// ./src/browser/components/opportunities/opportunity-card.js